<template>
<div class="header">
  <Row class="game-header" type="flex" justify="space-between" align="middle">
    <Col class="game-header-title-container">
      <Row>
        <h1 class="game-header-title">{{ title }}</h1>
        <p class="game-header-draw-no-container">
          {{ $t("general.draw_no") }}
          <span ref="header-draw-no"></span>
        </p>
      </Row>
    </Col>
  </Row>

  <div class="header-rebetbutton">
    <Col>
      <Row type="flex" align="middle">
        <rebet-bet-lot
          :type="type || 'o1'"
          :odd="odd(type)"
          :game="game"
          :game-data="gameData"
          :gameType="gameType"
          :minutes-string="minutesString"
          :seconds-string="secondsString"
          :disallow-betting="disallowBetting"
          :rebets="rebets"
          :norebetlast="norebetlast"
          :previousdrawno="previousdrawno"
        >
          <a
            :disabled="disallowBetting"
            class="game-header-button"
            :class="{ disabled: disallowBetting }"
            @click="rebetOnClick"
          >{{ $t("general.rebet") }}</a>
        </rebet-bet-lot>

        <div class="game-header-counter">
          <span class="timer">{{ minutesString[0] }}</span>
          <span class="timer">{{ minutesString[1] }}</span>
          <span class="game-header-counter-colon">:</span>
          <span class="timer">{{ secondsString[0] }}</span>
          <span class="timer">{{ secondsString[1] }}</span>
        </div>
      </Row>
    </Col>
  </div>

    </div>
</template>

<script>
import { Row, Col, Button } from "iview";
import axios from "../../configs/axios";
import NewBetLot from "../commons/NewBetLot";
import RebetBetLot from "../commons/RebetBetLot";
import gameHeaderMixin from "../../mixins/game-header-mixin";

export default {
  mixins: [gameHeaderMixin],
  components: {
    Row,
    Col,
    Button,
    NewBetLot,
    RebetBetLot,
  },
  data() {
    return {
      rebets: null,
      rebetLoading: false,
      norebetlast: false,
      previousdrawno: null,
      type: "",
      popperOptions: {
        placement: "bottom",
        hide: true,
        modifiers: {
          flip: { behavior: ["bottom"] },
          preventOverflow: {
            priority: ["left", "right", "top"],
            offset: { offset: "0,10px" }
          }
        }
      }
    };
  },
  watch: {
    rebets(newVal) {
      if (newVal && newVal.beton) {
        this.type = `o${newVal.beton[0].bet_type}`;
      }
    }
  },
  mounted() {
    this.rebetOnClick();
  },
  methods: {
    odd(type) {
      return this.gameData.odds && this.gameData.odds[type];
    },
    async rebetOnClick() {
      this.rebets = 1;

      this.norebetlast = false;
      let res = await axios(
        `${RebetUrl}&drawID=${this.gameData.previousdrawno}&gID=${this.gameData.gID}`
      );
      this.previousdrawno = this.gameData.previousdrawno;
      let resData = res.data;
      if (res != null) {
        this.norebetlast = true;
        if (resData.data != null) {
          this.rebets = resData.data;
        } else {
          this.norebetlast = false;
        }
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.game-header {
  position: relative;
  height: 45px;
  padding-left: 10px;
  padding-right: 10px;
  color: $header-title;
  background: $header-light-color;
  background: linear-gradient(
    180deg,
    $header-light-color 0%,
    $header-dark-color 100%
  );
  background-size: contain;
  border-radius: 4px 4px 0px 0px;
  box-shadow: 0 4px 4px 0px #00000015;
  font-size: 15px;
  font-weight: bold;
  cursor: all-scroll;
}

.header-rebetbutton{
  position: absolute;
  top: 10px;
  right: 0px;
  padding-right: 10px;
}

.header{
  height: 45px;
}

.game-header-title {
  display: block;
  line-height: 20px;
  text-transform: uppercase;
  font-size: 14px;
}

.game-header-draw-no-container {
  color: $game-header-draw-font-color;
  display: block;
  text-transform: uppercase;
  font-size: 10px;
  line-height: 14px;
}

.game-header-button {
  background-color: #223b6e;
  color: $tai-xiu-theme-color-5;
  border-radius: 6px;
  height: 26px;
  line-height: 26px;
  font-size: 10px;
  margin-right: 2px;
  margin-top: 0;
  padding: 0 8px;
  display: inline-block;
  font-weight: bolder;
  cursor: pointer;
  -webkit-box-shadow: rgba(40, 78, 102, 0.2) 0 4px 4px;
  box-shadow: 0 4px 4px rgba(40, 78, 102, 0.2);
  text-transform: uppercase;
  letter-spacing: 1px;
  z-index: 1;
}

.game-header-button.disabled {
  background: #eee;
  color: #888;
}

.game-header-button:hover {
  color: #57a3f3;
  background-color: white;
  border-color: #57a3f3;
}

.game-header-counter span.timer {
  background: $tai-xiu-theme-color-13;
  color: $tai-xiu-theme-color-5;
  padding: 0 5px;
  width: 20px;
  height: 26px;
  line-height: 26px;
  font-size: 15px;
  font-weight: bold;
  border-radius: 5px;
  text-align: center;
  display: inline-block;
  margin: 0 0 0 4px;
  -webkit-box-shadow: rgba(40, 78, 102, 0.2) 0 4px 4px;
  box-shadow: 0 4px 4px rgba(40, 78, 102, 0.2);
}

.game-header-counter .game-header-counter-colon {
  color: $header-title;
  background: transparent;
  text-align: center;
  padding: 0;
  width: auto;
  margin: 0 0 0 4px;
}

.game-header-title-container {
  flex: 1;
}

@media only screen and (max-width: 360px) {
  .game-header-button {
    margin-right: 5px;
    padding: 0 4px;
    margin-bottom: 0.1px;
  }

  .game-header-counter span {
    width: 18px;
    line-height: 26px;
    font-size: 12px;
    margin-top: 4px;
  }
}
</style>
